import {on} from "../jsbase/events";

export default {
    $el: null,
    $dropdownButton: null,
    $dropdownMenu: null,
    props: {
    },

    connect() {
        this.$el = $(this.el);
        let id = this.$el.attr('id');
        let displayValue = this.$el.find('option[value="'+this.$el.val()+'"]').text() || '';
        let value = this.$el.val();
        this.$dropdown = $('<div class="dropdown">' +
            '  <div class="input-group" id="'+id+'-dd" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' +
            '    <input readonly="readonly" class="bg-white form-control'+(this.$el.is('.form-control-sm') ? ' form-control-sm' : '')+' form-display" value="'+displayValue+'">' +
            '    <div class="input-group-append"><span class="input-group-text px-2"><i class="fa fa-angle-down"></i></span></div>' +
            '  </div>' +
            '  <div class="dropdown-menu" aria-labelledby="'+id+'-dd" style="width:100%;max-height:300px;overflow:auto;">' +
            '  </div>' +
            '</div>');
        this.$dropdownMenu = this.$dropdown.find('.dropdown-menu');
        this.$dropdownButton = this.$dropdown.find('.form-display');
        this.$el.after(this.$dropdown);
        this.$el.hide();
        this.$el.on('changed', (ev) => {
            this.$dropdownMenu.find('.bg-light').removeClass('bg-light');
            var selectedItem = this.$dropdownMenu.find('[data-value="'+$(this.$el).val()+'"]');
            selectedItem.addClass('bg-light').addClass('text-dark');
            this.$dropdownButton.val(selectedItem.attr('data-display'));
        });
        $.each(this.$el.find('>option,>optgroup'), (i, el) => {
            var me = $(el);
            if (me.is('optgroup')) {
                this.$dropdownMenu.append($('<div><strong class="text-left dropdown-header">' + me.attr('label') + '</strong></div>'));
                $.each(me.find('>option'), (i, groupEl) => {
                    this.addOptionItem($(groupEl), value);
                });
            } else {
                this.addOptionItem(me, value);
            }
        });
    },

    methods: {
        addOptionItem(me, value) {
            var selectedClass = me.attr('value') === value ? ' bg-light text-dark' : '';
            var option = $('<div class="dropdown-item linkify' + selectedClass + ' '+ (me.attr('class') || '') +'" data-value="' + me.attr('value') + '" data-display="' + me.text() + '">' + me.text() + '</div>');
            this.$dropdownMenu.append(option);
            on(option[0], 'click', this.selectItem);
        },
        selectItem(ev) {
            var value = $(ev.target).attr('data-value');
            this.$dropdownMenu.find('.bg-light').removeClass('bg-light').removeClass('text-dark');
            var selectedItem = this.$dropdownMenu.find('[data-value="'+value+'"]');
            selectedItem.addClass('bg-light').addClass('text-dark');
            this.$dropdownButton.val(selectedItem.attr('data-display'));
            $(this.$el).val(value).trigger('change');
        }
    },

}
